const { InspectorControls } = wp.blockEditor;
const { TextControl, SelectControl, PanelBody, ToggleControl } = wp.components;
import ImageControl from '../../wp-controlers/mediaUpload';
import CommonPanel from '../../wp-controlers/common-panel';

const Inspector = ({ attributes, setAttributes }) => {
  const {
    buttonHref,
    variant,
    size,
    iconPosition,
    hideOnDesktop,
    hideOnMobile,
    align,
    buttonTarget,
    target,
  } = attributes;

  return (
    <InspectorControls>
      <PanelBody title="Atributos do Botão" initialOpen={true}>
        <TextControl
          label="Url:"
          value={buttonHref}
          onChange={(buttonHref) => setAttributes({ buttonHref })}
        />

        <SelectControl
          label="Selecione estilo deste botão"
          title="Selecione estilo deste botão"
          value={variant}
          options={[
            { label: 'Padrão', value: 'default' },
            { label: 'Link azul bold', value: 'default-blue-bold' },
            { label: 'Com borda', value: 'bordered' },
            { label: 'Branco com borda', value: 'bordered-white' },
            { label: 'Laranja arredondado', value: 'btn-orange' },
            { label: 'Azul com ícone', value: 'withIcon' },
            { label: 'Azul Gradiente', value: 'blue-gradient' },
          ]}
          onChange={(position) => setAttributes({ variant: position })}
        />

        <ToggleControl
          label="Abrir o link em uma nova aba ?"
          checked={buttonTarget}
          onChange={() => setAttributes({ buttonTarget: !buttonTarget })}
        />

        <SelectControl
          label="Selecione a largura do botão"
          title="Selecione a largura do  botão"
          value={size}
          options={[
            { label: 'Padrão', value: '' },
            { label: 'Fit Content', value: 'auto-width' },
          ]}
          onChange={(position) => setAttributes({ size: position })}
        />

        <SelectControl
          label="Selecione a posição do botão"
          title="Selecione a posição do botão"
          value={align}
          options={[
            { label: 'Esquerda', value: 'left' },
            { label: 'Centro', value: 'center' },
            { label: 'Direita', value: 'right' },
            { label: 'Esquerda - Centro', value: 'left-center' },
            { label: 'Centro - Esquerda', value: 'center-left' },
          ]}
          onChange={(position) => setAttributes({ align: position })}
        />

        <ToggleControl
          label="Esconder botão em dispositivos móveis?"
          checked={hideOnMobile}
          onChange={() => setAttributes({ hideOnMobile: !hideOnMobile })}
        />

        <ToggleControl
          label="Esconder botão em desktop?"
          checked={hideOnDesktop}
          onChange={() => setAttributes({ hideOnDesktop: !hideOnDesktop })}
        />

        <ToggleControl
          label="Abrir modal de formulário"
          checked={target}
          onChange={() => setAttributes({ target: !target })}
        />
      </PanelBody>

      {variant == 'withIcon' && (
        <PanelBody title="Atributos do icone" initialOpen={true}>
          <ImageControl
            label="Imagem do botão"
            image="image"
            attributes={attributes}
            setAttributes={setAttributes}
          />

          <SelectControl
            label="Selecione a posição do icone"
            title="Selecione a posição do icone"
            value={iconPosition}
            options={[
              { label: 'direita', value: 'iconDefault' },
              {
                label: 'esquerda',
                value: 'iconReverse',
              },
            ]}
            onChange={(position) => setAttributes({ iconPosition: position })}
          />
        </PanelBody>
      )}

      <CommonPanel attributes={attributes} setAttributes={setAttributes} />
    </InspectorControls>
  );
};

export default Inspector;
